import React, { Dispatch, ReactNode, SetStateAction } from 'react';

import { intersection, not } from '../../helpers/filterObjects';
import { IListObjectInitialState } from '../../../../components/TransferList/CommonTransferList';
import { TransferList } from '../../../../components/TransferList/TransferList';
import {
    createHandleAdd,
    createHandleRemove,
} from '../../../../components/TransferList/helpers/transferHandlers';
import {
    IProductFilterInitialState,
    IProductsTransferListObject,
} from '../../types';

interface IOwnProps<T> {
    objectLists: IListObjectInitialState<T>;
    setObjectLists: React.Dispatch<Partial<IListObjectInitialState<T>>>;
    added: T[];
    setAdded: Dispatch<SetStateAction<T[]>>;
    removed: T[];
    setRemoved: Dispatch<SetStateAction<T[]>>;
    filter: IProductFilterInitialState;
    checked: T[];
    setChecked: Dispatch<SetStateAction<T[]>>;
    filterObjects: (items: T[], name: string) => T[];
    customComponents: { leftList: ReactNode; rightList: ReactNode };
}

export default function ProductTransferList<
    T extends IProductsTransferListObject
>(props: IOwnProps<T>) {
    const { filter, customComponents, objectLists, checked } = props;
    const { nameAssigned, nameUnassigned } = filter;
    const utils = { intersection, not };
    const handleAdd = createHandleAdd<T>({ props, name: nameAssigned, utils });
    const handleRemove = createHandleRemove<T>({
        props,
        name: nameUnassigned,
        utils,
    });

    return (
        <TransferList<T>
            objectLists={objectLists}
            checked={checked}
            customComponents={customComponents}
            intersection={intersection}
            handleAdd={handleAdd}
            handleRemove={handleRemove}
        />
    );
}
